
import { TaskStatus } from '@/context/TaskContext';

// Get status color class
export const getStatusColor = (status: TaskStatus): string => {
  switch (status) {
    case 'to-do': return 'before:bg-yellow-500'; // Yellow for To-Do
    case 'in-progress': return 'before:bg-blue-500'; // Blue for In Progress
    case 'done': return 'before:bg-green-500'; // Green for Done
    default: return '';
  }
};

// Format time to hours and minutes only
export const formatTaskTime = (seconds: number): string => {
  return `${Math.floor(seconds / 3600)}h ${Math.floor((seconds % 3600) / 60)}m`;
};
